








import Vue from 'vue'

export default Vue.extend({
  props: {
    mode: String,
    block: Boolean,
    circle: Boolean,
  },

  computed: {
    className(): any {
      const key = 'button-' + this.$props.mode

      const className: any = {}
      className[key] = true
      className['button-block'] = this.$props.block
      className['button-circle'] = this.$props.circle

      return className
    }
  },

  methods: {
    clickEvent(e: MouseEvent): void {
      this.$emit('click', e)
    }
  }
})
